import { createAction } from '@ngrx/store';

export const ToggleYoutubeModalAction = createAction(
  '[YouTube Modal] Toggle',
  (payload = null) => ({ payload })
);
export const ChangeVideoIdAction = createAction(
  '[YouTube Modal] Change Video ID',
  (payload = null) => ({ payload })
);
